const QUEBON_API = 'https://api.quebon.tv'

export interface QuebonReviewWriter {
  userId?: number
  name?: string
}

export interface QuebonReviewListItem {
  storyId: number
  title: string
  preview: string
  bestTitle?: string
  bestText?: string
  thumbnail?: string
  writer?: QuebonReviewWriter
  confirm?: boolean
}

export interface QuebonReviewListResponse {
  page: number
  totalPages: number
  best: QuebonReviewListItem[]
  list: QuebonReviewListItem[]
}

export interface QuebonReviewDetail {
  storyId: number
  title: string
  text: string
  views: number
  writer: QuebonReviewWriter
}

export async function fetchReviewList(
  page: number,
  count: number,
): Promise<QuebonReviewListResponse> {
  const res = await fetch(
    `${QUEBON_API}/user/v2/stories?page=${page - 1}&count=${count}`,
    { credentials: 'omit' },
  )
  if (!res.ok) {
    throw new Error(`Failed to load reviews: ${res.status}`)
  }
  return res.json()
}

export async function fetchReviewDetail(
  id: number,
): Promise<QuebonReviewDetail> {
  const res = await fetch(`${QUEBON_API}/user/v2/stories/${id}`, {
    credentials: 'omit',
  })
  if (!res.ok) {
    throw new Error(`Failed to load review ${id}: ${res.status}`)
  }
  return res.json()
}
